import type { Opportunity } from '../types/content';

/*
 * Approved leadership opportunities.
 * Only add genuine, approved vacancies. When connected to a CMS or database,
 * replace this array with fetched records of the same shape.
 */
export const opportunities: Opportunity[] = [];

export const seniorityLevels = ['Board / Non-Executive', 'C-Suite', 'Executive Committee', 'Senior Leadership'];

export const leadershipFunctions = [
  'General Management',
  'Finance',
  'Operations',
  'Technology',
  'People & HR',
  'Commercial & Marketing',
  'Legal & Governance',
  'Risk & Compliance',
  'Corporate Affairs',
];

export const regions = ['Africa', 'Europe', 'Middle East', 'North America', 'Latin America', 'Asia-Pacific', 'Remote / Flexible'];
